import React, { useState } from 'react';
import EventList from '../components/EventList';
import { GetStartedDialog } from '../components/GetStartedDialog';
import { HeroSection } from '../components/HeroSection';
import { MerchantSolutionsSection } from '../components/MerchantSolutionsSection';
import { PublisherSolutionsSection } from '../components/PublisherSolutionsSection';
import { SEO } from '../components/SEO';
import { TestimonialSection } from '../components/TestimonialSection';
import MainLayout from '../layouts/main';

export default () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  return (
    <MainLayout>
      <SEO />
      <HeroSection onGetStarted={() => setDialogOpen(true)} />
      <GetStartedDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
      />
      <PublisherSolutionsSection />
      <TestimonialSection />
      <MerchantSolutionsSection />
      <EventList />
    </MainLayout>
  );
};
